import React from 'react';
import meetingState from '../../../data/constants/meetingState';
import GroupMeeting from './GroupMeeting/GroupMeeting';
import SingleMeeting from './SingleMeeting/SingleMeeting';

function Meeting(props) {
    const {className = '', event, meeting} = props,
        classes = ['meeting', className];

    if (meeting._state == meetingState.CANCELLED) {
        classes.push('cancelled');
    }

    if (meeting.invited.length == 1) {
        return <SingleMeeting event={event} meeting={meeting} />;
    } else {
        return <GroupMeeting event={event} meeting={meeting} />;
    }
}

export default Meeting;
